import { FC } from "react";
import CustomPopup from "../CustomPopup/CustomPopup";
import { Box, Typography } from "@mui/material";
import noConnectionImage from "../../assets/images/no-connection.webp";
import { Colors } from "../../styles/constant";
import { defaultEmptyFun } from "../../utils/helper";

interface Props {
  open: boolean;
  onClick: () => void;
}

const CustomAppDownTimePopUp: FC<Props> = ({ open, onClick }) => {
  return (
    <CustomPopup handleOpen={defaultEmptyFun} open={open}>
      <Box padding="1.5rem 1rem">
        <Box display="flex" justifyContent="center">
          <img
            src={noConnectionImage}
            alt="no-connection"
            style={{ width: "12.25rem", height: "12.25rem" }}
          />
        </Box>
        <Box marginTop="1.5rem">
          <Typography textAlign="center" variant="h3">
            System Under Maintenance
          </Typography>
          <Typography
            marginTop="1rem"
            textAlign="center"
            variant="h5"
            paddingX="1.25rem"
            color={Colors.textGray}
          >
            This service is currently under maintenance. Please try again later.
          </Typography>
        </Box>
        {/* <Stack direction={"row"}>
          <Button
            fullWidth
            variant="contained"
            sx={{ margin: " 1rem .25rem .25rem  .25rem" }}
            onClick={() => onClick()}
          >
            Got it
          </Button>
        </Stack> */}
      </Box>
    </CustomPopup>
  );
};

export default CustomAppDownTimePopUp;
